export enum EContractType {
	NONE = 'NONE',
	INTERIM = 'INTERIM',
	CDD = 'CDD',
	CDI = 'CDI',
	SEASONAL = 'SEASONAL',
	VACATION = 'VACATION',
}

export enum EContractTypeSearch {
	ALL = 'ALL',
	NONE = 'NONE',
	INTERIM = 'INTERIM',
	SEASONAL = 'SEASONAL',
	CDD = 'CDD',
	CDI = 'CDI',
	VACATION = 'VACATION',
}
